import { lazy } from 'react';
import { Route } from 'react-router-dom';

const SsoCreate = lazy(() => import('./sso-create/sso-create.component'));
const SsoUpdate = lazy(() => import('./sso-update/sso-update.component'));

export const useSSORoutes = () => {
    return (
        <Route path='sso'>
            <Route
                path='create'
                element={<SsoCreate />}
            />
            <Route path=':ssoId'>
                <Route
                    path='update'
                    element={<SsoUpdate />}
                />
            </Route>
        </Route>
    );
};
